module.exports = __webpack_public_path__ + "img/shop-bg.5788de86.png";